module.exports = __webpack_public_path__ + "img/reinvite.053b4800.svg";